// API configuration
// Use relative URLs to work with proxy
const API_BASE_URL = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '');

// Canonical origin for outbound recipient-facing links (KDM emails, share
// download pages, venue request invites). MUST NOT be derived from
// window.location.origin — the operator UI is reachable on BOTH
// `screeners.hollywoodhills.media` (new canonical, v10.17.0+) and
// `screeners.hollywoodhillsmediagroup.com` (legacy, kept up so old emails
// resolve). If the operator browses the legacy hostname and copies a
// "KDM key" link, window.location.origin returns the legacy host — so
// the recipient gets a link they can technically open today but that
// reads like a regression and won't survive an eventual legacy turn-down.
//
// Mirrors the backend's utils/public_url.public_app_url fallback so the
// two sides agree byte-for-byte. Override via VITE_CANONICAL_ORIGIN at
// build time for dev / staging.
export const CANONICAL_ORIGIN =
  (import.meta.env.VITE_CANONICAL_ORIGIN || 'https://screeners.hollywoodhills.media')
    .replace(/\/$/, '');

const config = {
  API_URL: API_BASE_URL,
  CANONICAL_ORIGIN,
};

export default config;
